

enum AppMode {
  PRESENTATION = "presentation",
  TEXT = "text",
}

enum AppState {
  HEALTHY = "healthy",
  READY = "ready", // TODO: Not need? (got Healthy instead ??)
  ERROR = "error",

  LOADING = "loading",
  RETRYING = "retrying",
}

enum MessageType {
  LECTURE = "lecture",
  CHAT = "chat",
}

enum PromptType {
  GENERAL = "generalPrompt",
  GENERATE = "generatePrompt",
  QUESTION_ANSWER = "questionAnswer",
}

enum PromptTemplateType {
  EXPLICIT = "explicit",
  GENERATED = "generated",
}

enum SpeakerType {
  INSTRUCTOR = "instructor",
  STUDENT = "student",
}


export {
  AppMode,
  AppState,

  MessageType,
  PromptType,
  PromptTemplateType,

  SpeakerType,
}

